import { useQuery } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import { VoucherResponse } from "@/types";

type Props = {
  page?: string | null;
  per_page?: number | null;
  search?: string | null;
};

async function fetchVouchers({
  page,
  per_page,
  search,
}: Props): Promise<VoucherResponse> {
  const pageParams = `page=${page || 1}&per_page=${per_page || 10}&search=${
    search ?? ""
  }`;
  const response = await httpRequest.get<VoucherResponse>(
    `/vouchers?${pageParams}`
  );
  return response.data;
}

export function useFetchVouchersQuery({ page, per_page, search }: Props) {
  const vouchersQuery = useQuery({
    queryKey: ["vouchers", page, per_page, search],
    queryFn: () => fetchVouchers({ page, per_page, search }),
    keepPreviousData: true,
  });
  return {
    ...vouchersQuery,
    data: vouchersQuery.data,
  };
}
